module.exports = __webpack_public_path__ + "static/media/caixa.04d30705.png";